import React from 'react';

const TierCrest: React.FC<{
  color: string;
  label: string;
  className?: string;
}> = ({ color, label, className = 'w-16 h-[4.6rem]' }) => (
  <svg
    viewBox="0 0 100 116"
    className={className}
    role="img"
    aria-label={label}
  >
    <path
      d="M50 4 92 20v40c0 28-20 44-42 52C28 104 8 88 8 60V20Z"
      fill={color}
    />
    <path
      d="M50 30l6.5 13.2 14.6 2.1-10.5 10.3 2.5 14.5L50 63.3l-13.1 6.9 2.5-14.5-10.5-10.3 14.6-2.1Z"
      fill="#ffffff"
    />
    <text
      x="50"
      y="92"
      textAnchor="middle"
      fontFamily="Montserrat, sans-serif"
      fontSize="13"
      fontWeight="700"
      letterSpacing="1"
      fill="#ffffff"
    >
      {label}
    </text>
  </svg>
);

export default TierCrest;
